import { render, staticRenderFns } from "./add-invoice-content.vue?vue&type=template&id=47f2c9b6&scoped=true&"
import script from "./add-invoice-content.vue?vue&type=script&lang=js&"
export * from "./add-invoice-content.vue?vue&type=script&lang=js&"
import style0 from "./add-invoice-content.vue?vue&type=style&index=0&id=47f2c9b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f2c9b6",
  null
  
)

export default component.exports